import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";

import Login from './Pages/Dashboard/Login';
import Home from './Pages/Dashboard/Home';
import HomeDor from './Pages/Dor/Home';
import HomeCirurgias from './Pages/Cirurgias/Home';
import Search from './Pages/Dashboard/Search';
import Register from './Pages/Dashboard/Register';
import SoftwareSelection from './Pages/SoftwareSelection';
import { Layout } from './Components';
import ProtectedRoute from './protectRoute';
import ProductDetails from './Pages/Dashboard/ProductDetails';
import BotHistory from './Pages/Dashboard/BotHistory';
import DetalhePacienteDor from './Pages/Dor/DetalhePacienteDor';
import BotHistoryDor from './Pages/Dor/BotHistory';

// Importação dinâmica para evitar problemas de importação circular
const CadastroPacienteDor = lazy(() => import('./Pages/Dor/CadastroPacienteDor'));
const ListaPacientesDor = lazy(() => import('./Pages/Dor/ListaPacientesDor'));
const CadastroEfeitosAdversos = lazy(() => import('./Container/EfeitosAdversos/Cadastro'));
const ListaPriorizacao = lazy(() => import('./Pages/EfeitosAdversos/ListaPriorizacao'));
const CadastroPacienteCirurgias = lazy(() => import('./Pages/Cirurgias/CadastroPacienteCirurgias'));
const ListaPacientesCirurgias = lazy(() => import('./Container/Cirurgias/ListaPacientesCirurgias'));

const App = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="selecao-software" element={<ProtectedRoute><Layout><SoftwareSelection /></Layout></ProtectedRoute>} />
      
      {/* Rotas do Software de Dor */}
      <Route path="dor">
        <Route path="home" element={<ProtectedRoute><Layout><HomeDor /></Layout></ProtectedRoute>} />
        <Route path="pesquisa" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <ListaPacientesDor />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="cadastro" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <CadastroPacienteDor />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="lista" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <ListaPacientesDor />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="paciente/:id" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <DetalhePacienteDor />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="historico" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <BotHistoryDor />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
      </Route>

      {/* Rotas do Software de Efeitos Adversos */}
      <Route path="efeitos-adversos">
        <Route path="home" element={<ProtectedRoute><Layout><Home /></Layout></ProtectedRoute>} />
        <Route path="pesquisa" element={<ProtectedRoute><Layout><Search /></Layout></ProtectedRoute>} />
        <Route path="cadastro" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <CadastroEfeitosAdversos />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="lista-priorizacao" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <ListaPriorizacao />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="paciente" element={<ProtectedRoute><Layout><ProductDetails /></Layout></ProtectedRoute>} />
        <Route path="historico" element={<ProtectedRoute><Layout><BotHistory /></Layout></ProtectedRoute>} />
      </Route>

      {/* Rotas do Software de Cirurgias */}
      <Route path="cirurgias">
        <Route path="home" element={<ProtectedRoute><Layout><HomeCirurgias /></Layout></ProtectedRoute>} />
        <Route path="pesquisa" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <ListaPacientesCirurgias />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="cadastro" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <CadastroPacienteCirurgias />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="lista" element={
          <ProtectedRoute>
            <Layout>
              <Suspense fallback={<div>Carregando...</div>}>
                <ListaPacientesCirurgias />
              </Suspense>
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="paciente" element={<ProtectedRoute><Layout><ProductDetails /></Layout></ProtectedRoute>} />
        <Route path="historico" element={<ProtectedRoute><Layout><BotHistory /></Layout></ProtectedRoute>} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}

export default App;
